import { h } from "@stencil/core";

export default function ErrorMessage({
  errorMessage,
  onDismiss,
}: {
  errorMessage: string;
  onDismiss: () => void;
}): HTMLElement {
  return (
    <div class="error-message animated">
      <phn-p-inline-notification
        state="error"
        description={errorMessage}
        onDismiss={onDismiss}
      />
    </div>
  );
}
